// extracted by mini-css-extract-plugin
export default {"promos":"store-promos__promos___mL1R1"};